import { ApiReferenceReact } from '@scalar/api-reference-react';
import '@scalar/api-reference-react/style.css';
const BASE_URL = import.meta.env.VITE_BASE_URL;

export const ApiTokenDoc = () => {
  return (
    <ApiReferenceReact
      configuration={{
        url: `${BASE_URL}/public/doc.json`
      }}
    />
  );
};
